import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=ad3cd2f4&scoped=true&"
import script from "./FeaturesList.vue?vue&type=script&lang=js&"
export * from "./FeaturesList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesList.vue?vue&type=style&index=0&id=ad3cd2f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3cd2f4",
  null
  
)

export default component.exports